export default "__VITE_PUBLIC_ASSET__bb46e125__"